<!-- Module -->
<section *ngIf="!quizStart && !courseComplete && module">

  <!-- Header -->
  <div class="text-center">
      <!-- Title -->
      <h1>Module {{module.moduleNumber}} - {{module.title}}</h1>

      <!-- Admin Header -->
      <div *ngIf="previewByAdmin && page <= modulePages.length" class="admin-header text-center">
        <!-- Back -->
        <div class="back-to-admin">
          <button type="button" class="back btn custom text-primary" (click)="goBackToAdmin()"><mdb-icon fas icon="arrow-circle-left"></mdb-icon> Back to List</button>
        </div>

        <h2>
          <!-- Page -->
          <span>Page {{page}} / {{modulePages.length}}</span>

          <!-- Edit -->
          <a [routerLink]="" (click)="editPage()" class="edit-link ml-4">[Edit]</a>
        </h2>
      </div>
  </div>

  <!-- Module Content -->
  <ng-container *ngIf="page <= modulePages.length">
    <section *ngIf="!modulePage || (modulePage.type === 'Custom' && !loading)">
      <app-module-page-fhe [content]="modulePage" (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-module-page-fhe>
    </section>
  </ng-container>

</section>

<!-- Quiz Mode -->
<section *ngIf="quizStart && !courseComplete">
  <app-quiz-questions [questions]="questions" [moduleNumber]="moduleNumber" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>

<!-- Course Complete Page -->
<section *ngIf="previewByAdmin ? false : courseComplete">

  <!-- Message -->
  <div class="text-center">
      <h1 style="margin-bottom: 20px;">Congratulations! You've completed Housing Provider Education.</h1>
      <h4 style="margin-bottom: 20px;" *ngIf="user.ageUnder18 !== true">You may now add any properties you own or manage. Click 'Add Properties' to get started.</h4>
      <h5 style="margin-bottom: 60px;">If you are a tenant who took this for your own education, Thank you for learning more, but no other action is needed.</h5>

      <!-- Navigation Buttons -->
      <div class="certificate-btns">
          <button type="button" class="btn waves-dark w-25" (click)="courseComplete = false; back($event)"><i class="fas fa-angle-left mr-3"></i>Previous</button>
          <button type="button" class="btn waves-dark w-25" [routerLink]="'../../properties'" *ngIf="user.ageUnder18 !== true">Add Properties<i class="fas fa-angle-right ml-3"></i></button>
      </div>
  </div>
</section>

<!-- Course Complete Page -->
<!-- <section *ngIf="previewByAdmin ? false : courseComplete">


  <div class="text-center">
      <h1 style="margin-bottom: 20px;">Congratulations! You've completed Housing Provider Education.</h1>
      <h4 style="margin-bottom: 60px;">Click 'Get Certificate' to receive your personalized certificate.</h4>


      <div class="certificate-btns">
          <button type="button" class="btn waves-dark w-25" (click)="courseComplete = false"><i class="fas fa-angle-left mr-3"></i>Previous</button>
          <button type="button" class="btn waves-dark w-25" [routerLink]="'../../certificate'">Get Certificate<i class="fas fa-angle-right ml-3"></i></button>
      </div>
  </div>
</section> -->
